import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
var FormContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line
  registerForm: function registerForm() {},
  // eslint-disable-next-line
  unregisterForm: function unregisterForm() {}
});
var FormProvider = function FormProvider(_ref) {
  var children = _ref.children;
  var formContext = React.useContext(FormContext);
  var formsRef = React.useRef({});
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: _extends(_extends({}, formContext), {
      registerForm: function registerForm(name, form) {
        if (name) {
          formsRef.current = _extends(_extends({}, formsRef.current), _defineProperty({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm(name) {
        var newForms = _extends({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};
export { FormProvider };
export default FormContext;